module.exports = __webpack_public_path__ + "img/reset.10af03cc.svg";